import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 14px;
  gap: 10px;
  background: #fafafa;
  border: 1px solid #eeeeee;
  border-radius: 4px;
  margin-bottom: 10px;
`;

export const Horario = styled.div`
  font-family: 'Roboto';
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.75px;
  color: #8c8c8c;
`;

export const Parceiro = styled.div`
  font-family: 'Roboto';
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.02em;
  color: #595959;
`;

export const Status = styled.div`
  font-family: 'Roboto';
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.2px;
  color: #8c8c8c;
`;
